class TeamBlock {
    constructor(section) {
        this.section = section;
        this.links = Array.from(this.section.querySelectorAll('[data-team-block-anchor]'));
        this.sections = Array.from(this.section.querySelectorAll('.js-team-block-section'));
        this.observer = null;

        if (!this.links.length || !this.sections.length) {
            return;
        }

        this.init();
    }

    init() {
        this.bindAnchorLinks();
        this.initObserver();
    }

    bindAnchorLinks() {
        this.links.forEach((link) => {
            link.addEventListener('click', (event) => {
                const href = link.getAttribute('href');

                if (!href || !href.startsWith('#')) {
                    return;
                }

                const target = this.section.querySelector(href);

                if (!target) {
                    return;
                }

                event.preventDefault();

                target.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                });
            });
        });
    }

    initObserver() {
        this.observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (!entry.isIntersecting) {
                        return;
                    }

                    const activeId = entry.target.getAttribute('id');

                    this.links.forEach((link) => {
                        const isActive = link.getAttribute('href') === `#${activeId}`;
                        link.classList.toggle('is-active', isActive);
                    });
                });
            },
            {
                root: null,
                rootMargin: '-20% 0px -60% 0px',
                threshold: 0,
            }
        );

        this.sections.forEach((section) => {
            this.observer.observe(section);
        });
    }

    destroy() {
        if (this.observer) {
            this.observer.disconnect();
        }
    }

    static initAll() {
        const sections = document.querySelectorAll('.js-team-block');

        if (!sections.length) {
            return;
        }

        sections.forEach((section) => {
            if (section.teamBlockInstance) {
                return;
            }

            section.teamBlockInstance = new TeamBlock(section);
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    TeamBlock.initAll();
});